import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import UpdateCompanyData from './UpdateCompanyData';
import UpdateBrandingData from './UpdateBrandingData';
import CompanyDataDetail from './CompanyDataDetail';
import BrandingDataDetail from './BrandingDataDetail';
import OrganizationallyBelowPanel from './OrganizationallyBelowPanel';
import AdditionalRespondentInformation from './ARI/AdditionalRespondentInformation';
import RespondentDeletionRules from './RespondentDeletionRules';
import UpdateRespondentDeletionRules from './UpdateRespondentDeletionRules';
import YourGpiRepresentative from './YourGpiRepresentative';
import { parse } from 'query-string';

const SettingsDetail = ({ account, viewerRole }) => {
  const history = useHistory();
  const location = useLocation();

  const params = parse(location.search);
  const editCompanyDataFlag = params.editCompanyData || false;
  const editRespondentDeletionRulesFlag = params.editRespondentDeletionRules || false;

  const [editCompanyData, toggleEditCompanyData] = useState(editCompanyDataFlag);
  const [editBrandingData, toggleEditBrandingData] = useState(false);
  const [editRespondentDeletionRules, toggleEditRespondentDeletionRules] = useState(editRespondentDeletionRulesFlag);

  const { cldr } = useSelector((state) => state.i18n);

  const { gpiRepresentativeData } = account;

  const { country } = account.companyInformation;
  const countryDisplayName = cldr.teritoryDisplayName(country);

  return (
    <div className="p-grid brand-detailed-wrapper">
      <div className="p-col-12 p-md-6">
        {editCompanyData ? (
          <UpdateCompanyData
            toggleEdit={() => {
              toggleEditCompanyData(false);
              history.replace({
                search: '',
              });
            }}
          />
        ) : (
          <CompanyDataDetail
            account={account}
            countryDisplayName={countryDisplayName}
            toggleEdit={() => toggleEditCompanyData(true)}
            role={viewerRole}
          />
        )}

        <br />

        <AdditionalRespondentInformation />
      </div>
      <div className="p-col-12 p-md-6">
        {editBrandingData ? (
          <UpdateBrandingData toggleEdit={() => toggleEditBrandingData(false)} />
        ) : (
          <BrandingDataDetail account={account} toggleEdit={() => toggleEditBrandingData(true)} role={viewerRole} />
        )}

        <br />

        <OrganizationallyBelowPanel />

        <br />

        <YourGpiRepresentative gpiRepresentativeData={gpiRepresentativeData} />

        <br />

        {editRespondentDeletionRules ? (
          <UpdateRespondentDeletionRules
            account={account}
            toggleEdit={() => toggleEditRespondentDeletionRules(false)}
          />
        ) : (
          <RespondentDeletionRules
            account={account}
            toggleEdit={() => toggleEditRespondentDeletionRules(true)}
            role={viewerRole}
          />
        )}
      </div>
    </div>
  );
};

SettingsDetail.propTypes = {
  account: PropTypes.objectOf(PropTypes.any).isRequired,
  viewerRole: PropTypes.string.isRequired,
};

export default SettingsDetail;
